import type { SVGProps } from 'react';

export function FlowerGlyph(props: SVGProps<SVGSVGElement>) {
  return (
    <svg viewBox="0 0 32 32" aria-hidden="true" {...props}>
      <g className="flower-petals" fill="currentColor">
        <ellipse cx="16" cy="8.3" rx="4.4" ry="6.3" />
        <ellipse cx="23.3" cy="13.6" rx="4.4" ry="6.3" transform="rotate(72 23.3 13.6)" />
        <ellipse cx="20.5" cy="22.2" rx="4.4" ry="6.3" transform="rotate(144 20.5 22.2)" />
        <ellipse cx="11.5" cy="22.2" rx="4.4" ry="6.3" transform="rotate(216 11.5 22.2)" />
        <ellipse cx="8.7" cy="13.6" rx="4.4" ry="6.3" transform="rotate(288 8.7 13.6)" />
      </g>
      <circle className="flower-center" cx="16" cy="16" r="4.2" />
    </svg>
  );
}
